import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { useTheme } from 'styled-components';

export default function useSparkColor() {
  const { pathname } = useLocation();
  const theme = useTheme();

  const color = useMemo(() => {
    if (pathname.startsWith('/spark-liquidity-layer')) {
      return theme.colors.sparkLiquidityLayerColor;
    }
    if (pathname.startsWith('/savings')) {
      return theme.colors.sparkSavingsColor;
    }
    if (pathname.startsWith('/spk')) {
      return theme.colors.sparkSpkColor;
    }
    if (pathname.startsWith('/sparklend')) {
      return theme.colors.sparkLendColor;
    }
  }, [pathname, theme]);

  return color;
}
